import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    isLoginLinkExpiry = false;

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.subscriptions = this.route.queryParamMap.subscribe(paramMap => {
            if (paramMap.get('message') === 'Access expired.' || paramMap.get('error_description') === 'Access expired.') {
                this.isLoginLinkExpiry = true;
            }
            console.error('Unexpected error.');
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
